import React, { PropsWithChildren } from 'react';
import styled from '@emotion/styled';

import { IconVisibility } from './icons';

interface Props {
  count: number;
}

export const Count = styled.div`
  font-size: 12px;
  font-weight: normal;
  line-height: 1.33;
  letter-spacing: 0.4px;
  color: white;
  display: inline;
`;

export const ViewCount: React.FC<PropsWithChildren<Props>> = ({ count }) => (
  <>
    <IconVisibility />
    <Count aria-label="views count">{count}</Count>
  </>
);
